<template>
  <b-card no-body>
    <b-card-header>
      <b-card-title>Görüşme Geçmişi</b-card-title>
    </b-card-header>
    <b-table
      v-if="details.length > 0"
      responsive="sm"
      :fields="fields"
      :items="details"
      striped
    >
      <template #cell(company)="data">
        <div class="d-flex align-content-start align-items-center">
          <div>
            <b-button
              v-b-tooltip.hover.top="'Görüşmeyi Görüntüle'"
              variant="flat-success"
              class="btn-icon rounded-circle"
              :href="'/app/interviews/view/' + data.item.id"
              target="_blank"
            >
              <FeatherIcon icon="EyeIcon" />
            </b-button>
          </div>
          <div class="ml-1">
            <div>
              {{ data.item.company }}
            </div>
            <div class="text-primary font-small-2">
              {{ data.item.username }}
            </div>
            <div class="text-muted font-small-2">
              {{ moment(data.item.created).format('llll') }}
            </div>
          </div>
        </div>
      </template>
      <template #cell(interview_subject)="data">
        <div>
          {{ data.item.interview_subject }}
        </div>
        <div class="font-small-2 text-primary">
          {{ data.item.meet }}
        </div>
      </template>
      <template #cell(interview_status)="data">
        <div>
          {{ data.item.interview_status }}
        </div>
        <div
          class="font-small-2"
          :class="data.item.status === '0'? 'text-danger' : 'text-success'"
        >
          {{ data.item.status === '0'? 'Açık Görüşme' : 'Kapalı Görüşme' }}
        </div>
      </template>
    </b-table>
    <b-card-body v-else>
      <empty-alert />
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardTitle, BCardBody, BButton, BTable, VBTooltip,
} from 'bootstrap-vue'
import EmptyAlert from '@/views/Admin/Reports/common/EmptyAlert.vue'

export default {
  name: 'Interviews',
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BTable,
    BButton,
    EmptyAlert,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      currentPage: 1,
      perPage: 25,
      fields: [
        {
          key: 'company',
          label: 'FİRMA ADI',
        },
        {
          key: 'interview_subject',
          label: 'KONU',
        },
        {
          key: 'interview_status',
          label: 'DURUM',
        },
      ],
    }
  },
  computed: {
    details() {
      return this.$store.getters['customerReports/interviews']
    },
  },
  created() {
    this.getReport()
  },
  methods: {
    getReport() {
      this.$store.dispatch('customerReports/getInterviews', this.$route.params.id)
    },
  },
}
</script>
